"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHuawei = function SvgHuawei(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12h13.995c6.59 0 8.999 2.342 9.005 8.744v14.511C44 41.657 41.586 44 34.996 44H21c-6.592 0-9-2.343-9-8.745V20.744C12 14.342 14.408 12 21 12Zm-1.826 15.946h-.85v1.657h-1.919v-1.657h-.85v4.11h.85v-1.671h1.918v1.67h.851v-4.11Zm2.985 3.376c.615 0 .954-.355.954-1.023v-2.36h.85v2.322c0 1.178-.67 1.854-1.814 1.854-1.143 0-1.796-.657-1.796-1.819v-2.35h.849v2.323c0 .687.343 1.053.957 1.053Zm9.826-3.376.95 2.825.924-2.823h.88l-1.457 4.107h-.71l-.952-2.697-.953 2.697h-.704l-1.46-4.108h.906l.93 2.824.951-2.825h.695Zm5.828 2.34h-1.546v1.018h2.32v.75h-3.158v-4.105h3.082v.748h-2.244v.843h1.546v.747Zm2.632 1.763h-.84v-4.103h.84v4.103Zm-15.182.004.38-.856h1.918l.377.855h.89l-1.837-4.106h-.751l-1.846 4.107h.87Zm1.974-1.596h-1.28l.634-1.471.646 1.471ZM22.67 17.486c0 2.887 2.386 5.228 5.33 5.228a5.383 5.383 0 0 0 3.772-1.53 5.117 5.117 0 0 0 1.153-1.684 5.23 5.23 0 0 0 .412-2.014h-.755a4.475 4.475 0 0 1-2.262 3.968 4.67 4.67 0 0 1-2.317.618 4.669 4.669 0 0 1-2.318-.618 4.478 4.478 0 0 1-2.262-3.968h-.753Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHuawei);
var _default = exports["default"] = Memo;